import { IActiveModal } from "src/pages/Admin/AdminWindow";
import { DeviceDataGrid, IDeviceGridEndpoints } from "../DeviceGrid";

interface IUserDeviceDataGridProps {
  setActiveModal: (activeModal: IActiveModal | null) => void;
}

/**
 * Non-crew user devices, stored at `iOSDevices` on the root user record.
 *
 * Note the remove and activate/deactivate paths: this tab previously called
 * `/user/efb/device/{id}` and `/user/efb/set/{state}/{id}`, which the backend
 * has never routed - only `user/iosdevice/*` exists - so both buttons were
 * failing. They now point at the routes that are actually deployed.
 */
const USER_DEVICE_ENDPOINTS: IDeviceGridEndpoints = {
  list: "/user/iosdevice/list",
  invite: (userId) => `/user/iosdevice/invite/${userId}`,
  device: (deviceId) => `/user/iosdevice/device/${deviceId}`,
  setState: (state, deviceId) => `/user/iosdevice/set/${state}/${deviceId}`,
  bulkRemove: "/user/iosdevice/bulk/remove",
  bulkSetState: (state) => `/user/iosdevice/bulk/set/${state}`,
};

export const UserDeviceDataGrid = (props: IUserDeviceDataGridProps): JSX.Element => (
  <DeviceDataGrid
    setActiveModal={props.setActiveModal}
    endpoints={USER_DEVICE_ENDPOINTS}
    memberNoun="user"
    memberColumnHeader="User"
    // Preserves this tab's existing reading of batteryLevel as a 0-1 fraction.
    // See the note on the Crew Devices tab: the two disagree, and reconciling
    // them is deliberately out of scope for ENG-602.
    batteryScale={100}
    batteryWarnBelow={50}
    emptyMessage="No user devices have been registered yet."
  />
);

export default UserDeviceDataGrid;
